import { MouseEventHandler, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { ReactSVG } from 'react-svg'

import { useModalStore } from '@features/modal'
import { SearchInput } from '@features/search'

import { CategoriesBranch } from '@widgets/categories-branch'

import { cn } from '@shared/lib/cn'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

interface MobileSearchBarProps {
  className?: string;
  /*
    Landings drop the catalog button: they scope the visitor to their own
    assortment, so the site-wide category tree is off-topic there. Shown by
    default — the site header keeps it.
  */
  withCatalog?: boolean;
}

export default function MobileSearchBar ({ className, withCatalog = true }: MobileSearchBarProps) {
  const { t } = useTranslation('navigation')
  const navigate = useNavigate()
  const { openModal, closeModal } = useModalStore()

  const handleMenuBtnClick: MouseEventHandler = (e) => {
    e.preventDefault()
    openModal('categories', <CategoriesBranch />, {
      classes: {
        body: styles['modal-body'],
        content: styles['modal-content'],
      },
    })
  }

  useEffect(() => {
    closeModal('categories')
  }, [ navigate, closeModal ])

  return (
    <div className={cn(styles.mobileSearchBar, className)}>
      {withCatalog && (
        <Button onClick={handleMenuBtnClick} className={styles.mobileSearchBar__catalogButton}>
          <>
            <ReactSVG
              src="/icons/grid-black.svg"
              wrapper="span"
              className={styles.mobileSearchBar__catalogIcon}
            />

            <span className={styles.mobileSearchBar__catalogText}>
              {t('catalog')}
            </span>
          </>
        </Button>
      )}

      <div className={styles.mobileSearchBar__searchContainer}>
        <SearchInput className={styles.mobileSearchBar__search} />
      </div>
    </div>
  )
}
